import HealthNewsLetterPage from "@/containers/HealthNewsLetterPage";
//Redux
import { wrapper } from "@/redux/Store";

const HealthNewsletterSubscriptionPage = () => {
  return (
    <>
      <main>
        <h1 style={{ display: "none" }}>
          Shyft - Health & Wellness Platform | Shyft Health
        </h1>
        <HealthNewsLetterPage />
      </main>
    </>
  );
};

export default HealthNewsletterSubscriptionPage;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
  };
});
